export function updateSeatCount(seatCount) {
  return (dispatch) => {
    dispatch({ type: 'SEAT_COUNT_UPDATED', seatCount })
  }
}
